import { forwardRef, useMemo } from 'react'
import { Link as TanstackRouterLink, useSearch } from '@tanstack/react-router'

import { useExtractRootSearchParams } from '@/routes'

import { LinkProps } from './types'

export const RouterLink = forwardRef<HTMLAnchorElement, LinkProps>(
    (
        { className, to, params, search, activeOptions, inactiveClassName, activeClassName, onClick, title, children },
        ref
    ) => {
        const extractRootSearchParams = useExtractRootSearchParams()
        const searchParams = useSearch({
            strict: false,
        })

        // get and keep the root params in all links
        const rootSearchParams = useMemo(() => {
            return extractRootSearchParams(searchParams)
        }, [extractRootSearchParams, searchParams])

        return (
            <TanstackRouterLink
                ref={ref}
                // @ts-expect-error not sure how to fix this
                onClick={onClick}
                className={className}
                inactiveProps={{ className: inactiveClassName }}
                activeProps={{
                    className: activeClassName,
                    'aria-current': 'page',
                }}
                to={to}
                params={params}
                search={{
                    ...rootSearchParams,
                    ...search,
                }}
                activeOptions={activeOptions}
                title={title}
            >
                {children}
            </TanstackRouterLink>
        )
    }
)
